import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Personalinfo from './Personalinfo';
import Businessinfo from "./Businessinfo";
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useGlobalComponent } from '../../pages/commom/GlobalComponentProvider';
import { HasScreenPermissions } from '../../utils/Token';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
// import INFO from "../../utils/Enums.json";

import INFO from '../../pages/commom/RouteUrlInfo.json';



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Myaccount() {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const navigate = useNavigate();




  // const [value, setValue] = useState(0); // Initialize with the default tab index
  // // const defval=currentActiveSubTab?currentActiveSubTab:0

  // const location = useLocation();

  //  const handleChange = (event, newValue) => {
  //     setValue(newValue);
  //   };
  // useEffect(() => {
  //     setValue(currentActiveSubTab);
  // }, [currentActiveSubTab,location]);
  const { currentActiveTab, currentActiveSubTab } = useGlobalComponent();

  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    setValue(currentActiveSubTab);
  }, [currentActiveSubTab, location]);


  console.log(location?.pathname);
  return (

    <>

      <div className="row bg" style={{ minwidth: "100%", backgroundColor: "#F9FAFB", marginLeft: "auto",overflowX:"hidden" }}>
        <div className="col-sm-2 md-2 xl-2 block ">
          {/* <Button sx={{ textTransform: "capitalize" }} onClick={() => navigate("/DashBoard")}>{"<-- Back to dashboard"}</Button> */}
          <a href={"/DashBoard"} style={{ textTransform: "capitalize", textDecoration: "none", color: "rgb(97, 169, 251)" }} >{"<-- Back to dashboard"}</a>
        </div>
    
        <div className="col-sm-9 md-9 xl-9" >
          <Box sx={{ width: '100%' }}>
            <h1 className='mx-5 mt-3' style={{ color: 'rgb(0,0,0)' }} >My Account</h1>
            <Box >
              <Tabs className='mx-5' value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Main Information" {...a11yProps(0)}  hidden={HasScreenPermissions(INFO?.MyAccount?.actionName)}  style={{ textTransform: "inherit" }} />
                <Tab label="My company" {...a11yProps(1)}  hidden={HasScreenPermissions(INFO?.MyCompanyDetails?.actionName)} style={{ textTransform: "inherit" }} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}  hidden={HasScreenPermissions(INFO?.MyAccount?.actionName)} > 
              <Personalinfo />
            </TabPanel>
            <TabPanel value={value} index={1}  hidden={HasScreenPermissions(INFO?.MyCompanyDetails?.actionName)} >
              <Businessinfo />
            </TabPanel>

          </Box>
        </div>
        <div className="col-sm-1 md-1 xl-1 block"></div>

      </div>
    </>
  );
}
